import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import Select from 'react-select';

import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import moment from 'moment';

import * as actions from '../../actions/comprasespeciales';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';



const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const estados_compra = [
    {label: 'Pendiente', value: 0},
  {label: 'Comprado al Proveedor', value: 1},
  {label: 'En Transito al Storage', value: 2},
  {label: 'En Storage', value: 3},
  {label: 'En Transito a Maxicomm', value: 4},
  {label: 'Recibido En Maxicomm', value: 5},
  {label: 'Cancelado', value: 6},
];

class KardexProveedor extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           compra:[],
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 
       
        this.handleSelectChange2 = this.handleSelectChange2.bind(this);
    }



    handleInputChange(event) {
        let {compra} = this.state;

        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value=0;
            if(target.checked)
                value=1;
        }

        compra[name] = value;
        console.log('compra aqui----->',compra)
        this.setState({
            compra : compra
        });
    }
    handleSelectChange2(select, name) {

        let {compra} = this.state;
        const value = select === null ? null : select.value;
        compra[name] = value;
        this.setState({
            compra : compra
        });
    }

    buscar(evt){
    	evt.preventDefault();
      let {compra} = this.state;
      let self =this;
      this.props.guardando();
            api().post('/compra_especial/'+compra.id,compra)
            .then(function(response)
            {    
                   
                if(response.status === 200)
                {   
                   if(response.data.estado){
                    
                 self.props.alerta({
                    mensaje:"Se Cambio el estado de la Compra Especial",
                    tipo:"success",
                    creacion:moment().format('Y-MM-DD H:m:s'),
                  });
                 self.props.exito(response.data.compra);
                 self.props.toggle();


                   }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                  
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })

  
    }

    componentDidMount()
    {
        let compra_id = this.props.compra_id;
        let self = this;
        api().get('/compra_especial/'+compra_id)
        .then(function(response)
        {
            self.setState({
               compra : response.data,
            });
           
        })
    }

    render(){
    	let {compra} = this.state;
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                	<div className="row">
                		<div className="col-4">
                			<div className="form-group">
                   				<label>Fecha Estimada Arribo:</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_arribo"
                   					value={compra.fecha_arribo}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
               
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Estado *:</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="estado"
                              options={estados_compra}
                              value={ parseInt( compra.estado) }
                              onChange={ (select) => { this.handleSelectChange2(select, 'estado') } }
                              clearable={false}
                          />
                      </div>
                  </div>
                
                 
                
                	</div>
                  <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className>Nota</label>
                            <Input
                              rows={10}                                                        
                              type="textarea"
                              name="nota"
                              value={compra.nota} 
                              maxLength={349}
                              onChange={ this.handleInputChange}
                              />
                            
                        </div>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.comprasespeciales.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        comprasespeciales : state.comprasespeciales,
        auth:state.auth,
        notificciones:state.notificciones,
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/comprasespeciales/Modal.js